// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    const contactInfo = {
        emails: [
            { name: "General", email: "info@olpeal.com.ar" },
        ],
        phone: "+54 9 3544 63-9290",
        whatsapp: "https://wa.me/5493544639290",
    };

    const quickLinks = [
        { name: "Inicio", href: "#inicio" },
        { name: "Sobre Nosotros", href: "#nosotros" },
        { name: "Nuestros Productos", href: "#productos" },
        { name: "Nuestro Proceso", href: "#proceso" },
        { name: "Contacto", href: "#contacto" }
    ];

    const products = [
        { name: "Olivos y Aceitunas", href: "#productos" },
        { name: "Nueces de Pecan", href: "#productos" },
        { name: "Almendras", href: "#productos" },
    ];

    const socialMedia = [
        { icon: "fab fa-instagram", name: "Instagram", href: "https://www.instagram.com/olpeal.ar", color: "#E4405F" },
        { icon: "fab fa-youtube", name: "YouTube", href: "https://www.youtube.com/@olpeal_ar", color: "#FF0000" }
    ];

    return (
        <footer className="modern-footer">
            {/* Sección principal del footer */}
            <div className="footer-main">
                <div className="container">
                    <div className="footer-grid">

                        {/* Columna 1: Logo y descripción */}
                        <div className="footer-column logo-column">
                            <div className="footer-brand">
                                <div className="footer-logo">OLPEAL</div>
                                <div className="footer-tagline">OLIVOS. PECANES. ALMENDROS</div>
                            </div>
                            <p className="footer-description">
                                Dedicados al cultivo sostenible de olivos, pecanes y almendros,
                                produciendo alimentos de la más alta calidad con respeto por el medio ambiente.
                            </p>

                            {/* Redes sociales */}
                            <div className="footer-social">
                                <h4 className="social-title">Síguenos</h4>
                                <div className="social-icons-grid">
                                    {socialMedia.map((social, index) => (
                                        <a
                                            key={index}
                                            href={social.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="social-icon-item"
                                            style={{ '--social-color': social.color }}
                                            aria-label={social.name}
                                        >
                                            <i className={social.icon}></i>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Columna 2: Enlaces rápidos */}
                        <div className="footer-column">
                            <h3 className="column-title">Enlaces Rápidos</h3>
                            <ul className="footer-links">
                                {quickLinks.map((link, index) => (
                                    <li key={index}>
                                        <a href={link.href}>
                                            <i className="fas fa-chevron-right link-icon"></i>
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Columna 3: Productos */}
                        <div className="footer-column">
                            <h3 className="column-title">Nuestros Productos</h3>
                            <ul className="footer-links">
                                {products.map((product, index) => (
                                    <li key={index}>
                                        <a href={product.href}>
                                            <i className="fas fa-leaf link-icon product-icon"></i>
                                            {product.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Columna 4: Contacto */}
                        <div className="footer-column">
                            <h3 className="column-title">Contacto</h3>

                            {/* Teléfono */}
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <i className="fas fa-phone"></i>
                                </div>
                                <div className="contact-details">
                                    <h4>Teléfono</h4>
                                    <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="contact-link">
                                        {contactInfo.phone}
                                    </a>
                                </div>
                            </div>

                            {/* WhatsApp */}
                            <div className="contact-item">
                                <div className="contact-icon whatsapp-icon">
                                    <i className="fab fa-whatsapp"></i>
                                </div>
                                <div className="contact-details">
                                    <h4>WhatsApp</h4>
                                    <a href={contactInfo.whatsapp} target="_blank" rel="noopener noreferrer" className="contact-link whatsapp-link">
                                        Enviar mensaje
                                    </a>
                                </div>
                            </div>

                            {/* Emails */}
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div className="contact-details">
                                    <h4>Email</h4>
                                    <div className="email-list">
                                        {contactInfo.emails.map((email, index) => (
                                            <a key={index} href={`mailto:${email.email}`} className="email-link">
                                                {email.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* Sección de copyright */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="bottom-content">
                        <p className="copyright-text">
                            &copy; {currentYear} <strong>OLPEAL</strong> - Cultivo de Olivos, Pecanes y Almendros. Todos los derechos reservados.
                        </p>
                        <div className="footer-extra">
                            <a href="#" className="footer-extra-link">Política de Privacidad</a>
                            <span className="separator">|</span>
                            <a href="#" className="footer-extra-link">Términos y Condiciones</a>
                            <span className="separator">|</span>
                            <a href="#" className="footer-extra-link">Mapa del Sitio</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Botón para volver arriba */}
            <button
                className="back-to-top"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                aria-label="Volver arriba"
            >
                <i className="fas fa-chevron-up"></i>
            </button>
        </footer>
    );
}

export default Footer;